// ProductGallery.js
import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


export default function ProductGallery({ gallery = [] }) {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const slider1 = useRef(null);
  const slider2 = useRef(null);

  useEffect(() => {
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, []);

  const mainSettings = {
    asNavFor: nav2,
    ref: slider1,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: false,
    adaptiveHeight: true,
  };

  const thumbSettings = {
    asNavFor: nav1,
    ref: slider2,
    slidesToShow: Math.min(5, gallery.length || 5),
    slidesToScroll: 1,
    swipeToSlide: true,
    focusOnSelect: true,
    centerMode: false,
    infinite: true,
    arrows: false,
    dots: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: Math.min(4, gallery.length || 4) } },
      { breakpoint: 768, settings: { slidesToShow: Math.min(3, gallery.length || 3) } },
      { breakpoint: 480, settings: { slidesToShow: Math.min(2, gallery.length || 2) } },
    ],
  };

  if (!gallery || gallery.length === 0) {
    return <p>No images available</p>;
  } 
  return (
    <div className="product-gallery-wrapper">
      <div className="main-slider">
        <Slider {...mainSettings}>
          {gallery.map((item, i) => (
            <div className="main-slide" key={i}>
              <img src={item.image_url} alt={`slide-${i}`} className="img-fluid main-image" />
            </div>
          ))}
        </Slider>
      </div>
      <div className="thumb-slider">
        <Slider {...thumbSettings}>
          {gallery.map((item, i) => (
            <div className="thumb-slide" key={`t-${i}`}>
              <img src={item.image_url} alt={`thumb-${i}`} className="img-fluid thumb-image" />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
